export const SET_VOICE_MESSAGE = 'voiceMessageCreation/SET_VOICE_MESSAGE';

export const SET_IS_VOICE_MESSAGE_REHYDRATING =
  'voiceMessageCreation/SET_IS_VOICE_MESSAGE_REHYDRATING';

export const SET_IS_VOICE_MESSAGE_PLAYING =
  'voiceMessageCreation/SET_IS_VOICE_MESSAGE_PLAYING';

export const SET_IS_SHOWING_RECORD_AGAIN_CONFIRMATION_OVERLAY =
  'voiceMessageCreation/SET_IS_SHOWING_RECORD_AGAIN_CONFIRMATION_OVERLAY';

export const SET_IS_SHOWING_EXIT_CONFIRMATION_OVERLAY =
  'voiceMessageCreation/SET_IS_SHOWING_EXIT_CONFIRMATION_OVERLAY';

export const SET_LOGIN_EMAIL = 'voiceMessageCreation/SET_LOGIN_EMAIL';

export const SET_LOGIN_PASSWORD = 'voiceMessageCreation/SET_LOGIN_PASSWORD';

export const SET_SIGNUP_NAME = 'voiceMessageCreation/SET_SIGNUP_NAME';
export const SET_SINGNUP_EMAIL = 'voiceMessageCreation/SET_SIGNUP_EMAIL';
export const SET_SINGNUP_PASSWORD = 'voiceMessageCreation/SET_SIGNUP_PASSWORD';

export const SET_CURRENT_USER_EMAIL =
  'voiceMessageCreation/SET_CURRENT_USER_EMAIL';
export const SET_CAPTCHA = 'voiceMessageCreation/SET_CAPTCHA';

export const SET_EMAIL = 'voiceMessageCreation/SET_EMAIL';

export const SET_VOICE_MESSAGE_TITLE =
  'voiceMessageCreation/SET_VOICE_MESSAGE_TITLE';

export const SET_IS_LOADING = 'voiceMessageCreation/SET_IS_LOADING';
export const SET_IS_ERROR = 'voiceMessageCreation/SET_IS_ERROR';

export const SET_IS_NEW_USER = 'voiceMessageCreation/SET_IS_NEW_USER';

export const RESET = 'voiceMessageCreation/RESET';
